export default {
  main: {
    title: "トーン＆チャンネルマッピング",
  },
  drawer: {
    image: "画像",
    analysis: "ヒストグラム",
    palette: "パレット",
    ai: "AI インサイト",
  },
  card: {
    imageReference: "画像参照",
    histogram: "ヒストグラム",
    colorPalette: "カラーパレット",
    aiInsights: "AI インサイト",
  },
  tabs: {
    color: "カラー",
    tone: "トーン",
  },
  ai: {
    guideTitle: "AI インサイト",
    guideDescription:
      "AI 分析で色の内訳や構図の提案など、画像の深い洞察を取得します。",
    analyze: "AI で分析",
    refresh: "分析を更新",
    refreshTooltip: "分析を更新",
    analysisFailed: "分析に失敗しました: {message}",
  },
  aiAnalysis: {
    severity: {
      minor: "軽微",
      moderate: "中程度",
      major: "顕著",
      unknown: "未指定",
    },
  },
  taskSummary: {
    title: "タスク要約",
    currentTask: "現在のタスク：オリジナル → 目標スタイル（{styleName}）",
    currentTaskLabel: "現在のタスク：",
    currentTaskSource: "オリジナル",
    currentTaskTarget: "目標スタイル",
    unknownStyle: "スタイル未指定",
    keyGapsTitle: "主要ギャップ",
    priorityActionsTitle: "優先アクション",
    aiOverviewTitle: "後処理概要",
    aiDetailPreviewLabel: "完全な編集アドバイス",
    aiDetailCta: "編集方法を見る",
    aiDetailDialogTitle: "後処理提案の詳細",
    aiDetailTitle: "編集アドバイス",
    aiDetailClose: "閉じる",
    upgradedVersion: "更新済みバージョン",
    upgradeToView: "アップグレードして新しいバージョンを表示",
    aiDetailPendingBanner: "新しいバージョンを生成中です。完了後、自動的に現在の結果に置き換えられます",
    aiDetailPendingHint: "現在は旧バージョンの内容を表示しています。新しいバージョンが完了すると自動的に置き換えられます",
    aiDetailGenerating: "新しいバージョンの分析を生成中です。しばらくお待ちください...",
    actions: {
      uploadResult: "完成画像をアップロード",
      openGuide: "ガイドを見る",
    },
  },
  finalReview: {
    title: "完成画像レビューと共有",
    upload: {
      title: "完成画像をアップロード",
      description:
        "このタスクの完成画像（After）をアップロードし、Before/After プレビューと共有書き出しの準備を行います。",
      stateReady: "完成画像の準備完了",
      stateEmpty: "このタスクにはまだ完成画像がありません",
      template: "テンプレート",
      beforeSource: "Before ソース",
    },
    templatePreview: {
      before: "Before",
      after: "After",
    },
    uploading: "画像をアップロード中...",
    backToTask: "タスクへ戻る",
    replaceAfter: "After を置換",
    tabs: {
      slider: "Slider",
      sideBySide: "Side by Side",
    },
    moodFrame: {
      label: "Mood Frame",
    },
    actions: {
      download: "共有画像をダウンロード",
      generating: "生成中...",
    },
  },
  aiTaskSummary: {
    title: "AI タスク総覧",
    loading: "AI がタスク総覧を生成中です...",
    placeholder:
      "AI 総覧はまだ準備中です。先に下部のインサイト詳細を確認できます。",
    temporaryIssue:
      "今回の分析で一時的な問題が発生しました。時間をおいて再度お試しください。",
  },
  pending: {
    public: {
      title: "写真を分析しています",
      description:
        "参考画像と照合しながら、画面構造・色分布・編集ギャップを解析しています。完了後、自動的に結果ページへ進みます。",
      primary: "画像構造を分解しています。しばらくお待ちください…",
      stages: {
        preparing: "分析環境を準備しています…",
        scanning: "写真の構造と明暗階層をスキャンしています…",
        locating: "色分布に基づいてギャップを特定しています…",
        generating: "参考画像をもとに後続のレタッチ提案を生成しています…",
      },
    },
    internal: {
      titleLoading: "分析コンテキストを読み込み中...",
      titleReady: "分析タスクを準備中",
      description:
        "システムが分析環境を初期化中です。準備が完了したら結果ページに自動的に移動します。",
    },
    steps: {
      auth: "ユーザーIDを検証中",
      capability: "機能設定を読み込み中",
      unlock: "ロック解除状態を復元中",
      analyzing: "分析を準備中",
      crop_deciding: "切り抜き結果を待機中",
      submitting: "分析タスクを送信中",
    },
    recovery: {
      processedReupload:
        "処理画像リソースが期限切れです。現在の素材で処理画像を再アップロードして再試行します。",
      originalReupload:
        "原図リソースが期限切れです。アップロードページに戻って分析素材を再作成してください。",
      multipleAssets:
        "分析素材が不完全です。アップロードページに戻って原図と処理画像を準備してください。",
      manualRecovery:
        "現在の分析タスクは自動復元できません。ページを更新するか、後でもう一度分析を開始してください。",
    },
    actions: {
      retryProcessed: "処理画像を再アップロードして送信",
      retrySubmit: "分析タスクを再送信",
    },
    errors: {
      insufficient_credits:
        "クレジットが不足しています。分析タスクは実行されませんでした。",
      history_quota_exceeded:
        "履歴クォータの上限に達しました。分析タスクは実行されませんでした。",
      payment_materialization_pending:
        "支払い状態が同期中です。しばらくしてから再送信してください。",
      invalid_upload_asset:
        "アップロード資産がまだ準備できていません。再送信してください。",
      image_missing:
        "分析リソースが不足しています。アップロードページに戻って再送信してください。",
      source_not_ready:
        "分析ソースがまだ準備できていません。しばらくしてから再送信してください。",
      processed_mismatch:
        "処理画像が現在の原図と一致しません。再生成してからお試しください。",
      analysis_not_ready_for_execution:
        "ローカル分析が完了していません。準備が完了したら続行します。",
      analysis_subject_id_required:
        "結果の同期に失敗しました。再送信するか、ページを更新してください。",
      subject_not_found:
        "サーバーの結果が利用できません。しばらくしてから再同期してください。",
      not_implemented:
        "サーバーで現在の分析インターフェースがまだ有効になっていません。しばらくしてからお試しください。",
      network_timeout:
        "ネットワークリクエストがタイムアウトしました。しばらくしてからお試しください。",
      network_error:
        "ネットワークエラー。分析タスクの送信に失敗しました。再試行してください。",
      server_error:
        "サーバーエラー。分析タスクの送信に失敗しました。再試行してください。",
      server_unavailable:
        "サーバーが一時的に利用できません。再試行してください。",
      analysis_command_failed:
        "分析タスクの送信に失敗しました。しばらくしてからお試しください。",
      fallback:
        "分析タスクの送信に失敗しました。しばらくしてからお試しください。",
      bootstrap_error:
        "分析の準備に失敗しました。アップロードページに戻って再試行してください。",
    },
  },
  relation: {
    errors: {
      network_error: "ネットワークエラー",
      retry_failed: "操作に失敗しました",
      manual_fallback: "手動でレガシーロジックにフォールバック",
      not_found_max_attempt: "自動アップロードの再試行回数を超過",
      not_found: "リソースが見つかりません",
      relation_missing_max_attempt: "自動作成の再試行回数を超過",
      relation_missing_failed: "リレーションの作成に失敗しました",
      relation_restore_max_attempt: "自動復元の再試行回数を超過",
      relation_restore_failed: "リレーションの復元に失敗しました",
      processed_mismatch_max_attempt: "自動上書きの再試行回数を超過",
      processed_mismatch_failed: "処理画像の上書きに失敗しました",
      missing_relation_id: "relation_id が不足しています",
    },
  },
  featureGate: {
    titles: {
      unavailable_tier: "現在のプランはこの機能をサポートしていません",
      insufficient_credits: "クレジットが不足しています",
      locked: "この機能はロック解除が必要です",
      default: "この機能は現在利用できません",
    },
    descriptions: {
      unavailable_tier: "プランをアップグレードしてからお試しください。",
      insufficient_credits:
        "コインにトップアップまたはアップグレードしてください。",
      locked: "クレジットを消費して、現在の画像でこの機能をロック解除します。",
      default:
        "しばらくしてからお試しいただくか、コインにアクセスしてください。",
    },
    statusLabels: {
      unavailable_tier: "プラン制限",
      insufficient_credits: "クレジット不足",
      locked: "ロック中",
      default: "利用不可",
    },
    primaryActions: {
      locked: "今すぐロック解除",
      need_confirm: "今すぐロック解除",
      upgrade_only: "プランをアップグレード",
      insufficient_credits: "トップアップ/アップグレード",
      default: "コインにアクセス",
    },
    secondaryActions: {
      dismiss: "キャンセル",
      learn_more: "詳しく見る",
      later: "後で",
      locked: "詳しく見る",
      need_confirm: "詳しく見る",
      upgrade_only: "詳しく見る",
      insufficient_credits: "後で",
    },
  },
  guideFlow: {
    eyebrow: "初心者ガイド",
    title: "あなたの写真を、一歩ずつ読み解く",
    stepIndex: "ステップ {current} / {total}",
    actions: {
      back: "戻る",
      next: "次へ",
      complete: "ガイドを完了",
      exit: "ガイドを終了",
      skipToTasklayout: "先にタスク概要へ進む",
    },
    aiGate: {
      title: "AI ギャップ分析を準備中",
      description:
        "AI がギャップステップを生成中です。準備ができ次第、そのまま次へ進めます。",
      waiting: "AI が分析中です。しばらくお待ちください…",
      timeout:
        "90 秒以上待機しました。先にタスク概要へ進み、後でガイドを再開できます。",
      timeoutDescription:
        "待機がタイムアウトしました。先にタスク概要へ進み、後で「ガイドを見る」から再開できます。",
      temporaryIssue:
        "今回の分析で一時的な問題が発生しました。時間をおいて再度お試しください。",
      positive: {
        primary:
          "画像構造をスキャンして分解しています。しばらくお待ちください…",
        messages: {
          0: "写真の構造と明暗階層をスキャンしています…",
          1: "色分布に基づいてギャップを特定しています…",
          2: "参考画像をもとに後続のレタッチ提案を生成しています…",
        },
      },
    },
    gap: {
      defaultTitle: "Gap Step {index}",
      fallbackDiagnosis:
        "このステップで表示できるギャップ診断はまだありません。",
      suggestionLabel: "推奨アクション：",
      evidenceLabel: "証拠アンカー：",
      restrictedDescription:
        "このステップを解放すると、完全な診断・推奨アクション・証拠位置を確認できます。",
      dataReadingTitle: "データ読み取り",
      evidenceAriaLabel: "データ解釈",
      toggleEvidenceSummaryAriaLabel: "データ要約を展開または折りたたむ",
      evidenceGroupsHeader: "現在の動的ステップ evidence_groups",
      analysisMarkdown: {
        title: "AI 分析結果",
        description:
          "このステップでは一時的に AI が返した分析 markdown を表示します。後続でより細かい動的ステップに置き換える予定です。",
        empty:
          "AI 分析内容はまだ利用できません。しばらくしてから再度お試しください。",
      },
      empty: {
        title: "表示可能なギャップは未検出です",
        description:
          "このタスクには現在表示できる gap 項目がありません。ガイドを完了してタスク概要へ進めます。",
      },
    },
    hueMapping: {
      emptyHint: "色相範囲を選択すると、両方の画像での分布位置を確認できます。",
      selectedHint: "現在表示中：{label}",
      luminanceZoneLabel: "輝度ゾーン",
      globalPercentHint:
        "色相の比率は画像全体の統計です。輝度ゾーンを選ぶと、そのゾーン内にプレビュー mask を制限できます。",
      zonePercentHint: "色相の比率は選択中の輝度ゾーン内で計算されます。",
    },
    saturationMapping: {
      emptyHint:
        "彩度レベルを選択すると、両方の画像での分布位置を確認できます。",
      selectedHint: "現在表示中：{label}",
      luminanceZoneLabel: "輝度ゾーン",
      globalPercentHint:
        "左側の割合は画像全体の統計です。輝度ゾーンを選ぶと、右側はそのゾーン内で一致したマスクのみ表示します。",
      zonePercentHint:
        "左側の割合は選択中の輝度ゾーン内で算出されます。右側はそのゾーン内で一致したマスクのみ表示します。",
      uploadCard: "彩度分布 · アップロード画像",
      referenceCard: "彩度分布 · 参照画像",
      buckets: {
        low: "低彩度",
        muted: "やや低彩度",
        medium: "中彩度",
        vibrant: "やや高彩度",
        high: "高彩度",
      },
    },
    labAbMapping: {
      emptyHint:
        "A または B チャンネルの分档を選択し、両方の画像で該当する色かぶり領域を確認します。",
      selectedHint: "現在表示中：{label}",
      luminanceZoneLabel: "輝度ゾーン",
      globalPercentHint:
        "左側の割合は画像全体の統計です。輝度ゾーンを選ぶと、右側はそのゾーン内で一致したマスクのみ表示します。",
      zonePercentHint:
        "左側の割合は選択中の輝度ゾーン内で算出されます。右側はそのゾーン内で一致したマスクのみ表示します。",
      channelA: {
        title: "A チャンネル · グリーン ↔ レッド/マゼンタ",
        buckets: [
          "強いグリーン寄り",
          "ややグリーン寄り",
          "ニュートラル",
          "ややレッド/マゼンタ寄り",
          "強いレッド/マゼンタ寄り",
        ],
      },
      channelB: {
        title: "B チャンネル · ブルー ↔ イエロー",
        buckets: [
          "強いブルー寄り",
          "ややブルー寄り",
          "ニュートラル",
          "ややイエロー寄り",
          "強いイエロー寄り",
        ],
      },
    },
    placeholders: {
      rgb: {
        title: "RGB ヒストグラム概要",
        description:
          "アップロード画像と参照画像の RGB ヒストグラムと重ね表示を比較し、色チャンネルの傾向差を把握します。",
      },
      luminosity: {
        title: "Luminosity ヒストグラム概要",
        description:
          "輝度分布を比較して、全体の階調バランス差と露出のズレを素早く確認します。",
      },
      mask: {
        title: "Mask 概要",
        description:
          "ゾーンマスクのプレビューで領域ごとの見え方を把握し、次の gap ステップへつなげます。",
      },
      hueMapping: {
        title: "HUE マッピング",
        description:
          "左右の色相リングで色相を選択し、アップロード画像と参照画像でその色相が分布する領域を同期表示します。",
        luminanceZoneLabel: "輝度ゾーン",
        globalPercentHint:
          "色相の比率は画像全体の統計です。輝度ゾーンを選ぶと、そのゾーン内にプレビュー mask を制限できます。",
        zonePercentHint: "色相の比率は選択中の輝度ゾーン内で計算されます。",
      },
      clippingMapping: {
        title: "白飛び/黒つぶれマッピング",
        description:
          "輝度クリッピング閾値に基づき、アップロード画像と参照画像の白飛び・黒つぶれ領域を同期表示します。",
      },
      zoneBoxplotSnapshot: {
        title: "ゾーンマスクと統計スナップショット",
        description:
          "上部のゾーン選択をそのまま使い、明度マスク表示と対応ゾーンの箱ひげ比較を下部で連動表示します。",
      },
    },
  },
  atomicCapabilities: {
    title: "インサイト詳細",
    tabs: {
      image: "Image",
      tonalExposure: "Tonal & Exposure",
      globalColor: "Global Color",
      colorGrading: "Color Grading",
      aiInsights: "AI Insights",
    },
    image: {
      resolution: "解像度",
      totalPixels: "総ピクセル",
      megapixels: "メガピクセル",
      aspectRatio: "縦横比",
      fileFormat: "ファイル形式",
      sourceLabel: "アップロードソース",
      activeBadge: "Active",
      previewAction: "画像プレビュー: {subject}",
      previewAltOriginal: "アップロード元画像プレビュー",
      previewAltCropped: "アップロードクロップ画像プレビュー",
      previewAltReference: "参照画像プレビュー",
      unavailable: "画像を表示できません",
      referenceMissing: "参照画像がありません",
      downloadCropped: "クロップ画像をダウンロード",
    },
    statistics: {
      tonalExposureTitle: "輝度メトリクス（Global）",
      globalColorTitle: "全体彩色メトリクス（Global）",
      snapshotTitle: "色度プロファイル",
      mean: "Mean",
      median: "Median",
      std: "Std",
      channels: {
        labL: "LAB L",
        hslL: "HSL L",
        hslH: "HSL H",
        hslS: "HSL S",
        labA: "LAB A",
        labB: "LAB B",
      },
    },
    colorGrading: {
      zoneLabel: "ゾーン選択",
      labTitle: "LAB 統計（{zone}）",
      hslTitle: "HSL 統計（{zone}）",
      downloadLab: "LAB 統計をダウンロード",
      downloadHsl: "HSL 統計をダウンロード",
      empty: "このゾーンの統計データはありません",
      tendencyTitle: "ゾーン傾向の解釈",
      zone: {
        global: "Global",
        blacks: "Blacks",
        shadows: "Shadows",
        midtones: "Midtones",
        highlights: "Highlights",
        whites: "Whites",
      },
      tendency: {
        temperatureCool:
          "LAB B が中性色より低く、このゾーンは寒色寄り（青/シアン）です。",
        temperatureWarm:
          "LAB B が中性色より高く、このゾーンは暖色寄り（黄/橙）です。",
        temperatureNeutral:
          "LAB B が中性色付近で、このゾーンの暖色/寒色傾向は弱いです。",
        tintGreen:
          "LAB A が中性色より低く、わずかにグリーン寄りの傾向があります。",
        tintMagenta:
          "LAB A が中性色より高く、わずかにマゼンタ寄りの傾向があります。",
        tintNeutral:
          "LAB A が中性色付近で、このゾーンのグリーン/マゼンタ傾向は弱いです。",
        saturationLow: "HSL S が低く、このゾーンの彩度は弱めです。",
        saturationMedium: "HSL S が中間域で、このゾーンの彩度は中程度です。",
        saturationHigh: "HSL S が高く、このゾーンの彩度は強めです。",
        luminanceDark: "HSL L が低く、このゾーン全体は暗めです。",
        luminanceNeutral: "HSL L が中間域で、このゾーンの明るさは中立です。",
        luminanceBright: "HSL L が高く、このゾーン全体は明るめです。",
        hslLightnessTitle: "HSL 明度ノート",
        hslHueTitle: "HSL 色相ノート",
        hslSaturationTitle: "HSL 彩度ノート",
        empty:
          "このゾーンの統計が不足しているため、傾向の解釈を生成できません。",
      },
    },
  },
  gapCards: {
    title: "ギャップ",
    cardTitle: "ギャップカード",
    drawerOpen: "ギャップを展開",
    drawerClose: "ギャップを折りたたむ",
    gapScore: "ギャップスコア {score}",
    gapConclusion: "現在は{current}で、目標の{target}との差が大きい状態です。",
    actionSuggestion: "まずは{action}を実行することを推奨します。",
    riskHint: "処理が過剰になると、{risk}が発生する可能性があります。",
    viewAll: "一時的に全件表示",
    viewAllDialogTitle: "Comparison 分析ログ（暫定）",
    viewAllTabFull: "完全ログ",
    viewAllTabProcessed: "処理後ログ",
    viewAllTabHistogramAi: "ヒストグラム AI 入力",
    noLogData: "comparison ログデータはまだありません。",
    noProcessedLogData: "処理後ログデータはまだありません。",
    noHistogramAiData: "ヒストグラム AI 入力データはまだありません。",
    downloadJson: "JSON をダウンロード",
    expandEvidence: "詳細を表示",
    viewDetails: "詳細を見る",
    evidenceComingSoon: "詳細表示は近日対応予定",
    untitledGap: "差分項目 {index}",
    labels: {
      current: "現状",
      target: "目標",
      source: "ソース",
      reference: "リファレンス",
    },
    fallback: {
      tone: {
        title: "露出階調のギャップ",
        currentState: "ハイライトが硬く、シャドウ階調が不足している",
        targetState: "ハイライトが柔らかく、シャドウの質感が残っている",
        actionHint: "先にハイライトを回収し、その後ブラックを少し持ち上げる",
        riskNote: "ハイライト回収をやりすぎると画が眠くなる",
      },
      color: {
        title: "全体彩色傾向のギャップ",
        currentState: "全体が寒色寄りで肌にシアンかぶりがある",
        targetState: "ニュートラル寄りの暖色で肌色が自然",
        actionHint: "まずWBを調整し、その後シアン寄りを抑える",
        riskNote: "暖色を強めすぎると肌がオレンジに転ぶ",
      },
      contrast: {
        title: "コントラストリズムのギャップ",
        currentState: "中間調が詰まり、コントラストのリズムが平坦",
        targetState: "中間調が整理され、階調の抑揚がある",
        actionHint: "先に中間調を開き、次に黒白点を整える",
        riskNote: "コントラストを上げすぎるとシャドウが潰れる",
      },
    },
  },
  gapDetail: {
    previousGap: "前へ",
    nextGap: "次へ",
    gapSelectorLabel: "差分項目を切り替え",
  },
  compareStage: {
    title: "2画像比較",
    subjectLabel: "比較対象",
    uploadViewLabel: "アップロード画像の版",
    subjects: {
      upload: "アップロード画像",
      reference: "参考画像",
    },
    views: {
      original: "オリジナル",
      processed: "処理済み",
      cropped: "クロップ画像",
    },
    metrics: {
      exposureDelta: "露出差",
      contrastDelta: "コントラスト差",
      temperatureDelta: "色温度差",
      saturationDelta: "彩度差",
    },
    errors: {
      referenceLoadFailed: "参考画像の読み込みに失敗しました。再試行できます。",
      referenceMissing: "参考画像が見つかりません（コンテキストが無効です）。",
    },
    actions: {
      retry: "再試行",
      downloadReference: "参考画像をダウンロード",
      openEvidence: "証拠を見る",
      expand: "展開",
      collapse: "折りたたむ",
    },
  },
  // 1-A：手机档（≤720）分段导航（四段：摘要 / 对照 / 缺口 / 洞察）。key 取通用含义，不绑定具体措辞。
  segments: {
    ariaLabel: "結果セクション",
    summary: "サマリー",
    compare: "比較",
    gaps: "ギャップ",
    insights: "インサイト",
  },
  summaryBar: {
    targetLabel: "ターゲット",
    gapsLabel: "主要ギャップ",
    gapsNone: "なし",
    expand: "タスク概要を表示",
    collapse: "タスク概要を隠す",
  },
  imageDisplay: {
    original: "オリジナル",
    analyzed: "解析済み",
    borderCropping: "ボーダークロップ",
    downloadOriginal: "オリジナルをダウンロード",
    downloadProcessed: "処理済みをダウンロード",
    originalImage: "オリジナル画像",
    originalImageFull: "オリジナル画像（全体）",
    processedImage: "処理済み画像",
    processedImageFull: "処理済み画像（全体）",
  },
  confirmDialog: {
    cancel: "キャンセル",
    creditsRequired: "予想クレジット消費",
    upgrade: {
      title: "AI 分析バージョンのアップグレード確認",
      currentVersion: "現在のバージョン",
      targetVersion: "目標バージョン",
      executing: "アップグレード中...",
      targetReady:
        "目標バージョンの結果が準備完了です。アップグレード後すぐに確認できます。",
      upgrading: "アップグレード中",
      confirm: "アップグレードを確認",
    },
    unlock: {
      title: "ロック解除の確認",
      balanceTotal: "利用可能クレジット",
      executing: "ロック解除中...",
      unlocking: "ロック解除中",
      confirm: "ロック解除を確認",
      messageZero:
        "この機能はクレジットを消費しません。ロック解除を続行しますか？",
      messageSingular:
        "この機能は 1 クレジット消費します。ロック解除を続行しますか？",
      messagePlural:
        "この機能は {credits} クレジット消費します。ロック解除を続行しますか？",
      messageUnknown:
        "この機能はクレジット消費があります。ロック解除を続行しますか？",
    },
  },
};
